(() => {
  const updateFaqSchema = () => {
    const entries = Array.from(document.querySelectorAll('.collection__guide details')).flatMap((detail) => {
      const summary = detail.querySelector('summary');
      if (!summary) return [];
      const answer = detail.cloneNode(true);
      answer.querySelector('summary').remove();
      const name = summary.textContent.replace(/\s+/g, ' ').trim();
      const text = answer.textContent.replace(/\s+/g, ' ').trim();
      return name && text ? [{ '@type': 'Question', name, acceptedAnswer: { '@type': 'Answer', text } }] : [];
    });
    document.getElementById('CaseBearCollectionFAQ')?.remove();
    if (!entries.length) return;
    const schema = document.createElement('script');
    schema.id = 'CaseBearCollectionFAQ';
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: entries });
    document.head.appendChild(schema);
  };
  updateFaqSchema();
  document.addEventListener('shopify:section:load', updateFaqSchema);
})();
